import { render } from "./WindowButtonsWeb.vue?vue&type=template&id=492472d0&ts=true"
import script from "./WindowButtonsWeb.vue?vue&type=script&lang=ts"
export * from "./WindowButtonsWeb.vue?vue&type=script&lang=ts"

import "./WindowButtonsWeb.vue?vue&type=style&index=0&id=492472d0&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__